import { SyntheticEvent, useEffect, useState } from 'react';

// material-ui
import { Alert, Snackbar } from '@mui/material';

// project import
import IconButton from './IconButton';

// assets
import { CloseOutlined } from '@ant-design/icons';

import { SnackbarService } from 'Services/Snakbar/SnakbarService';
import { observer } from 'mobx-react-lite';

// ==============================|| SNACKBAR ||============================== //

const MSnackbar = observer(() => {
  const [severity, setSeverity] = useState<any>('error');

  const handleClose = (event: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    SnackbarService.setOpenfalse();
  };

  useEffect(() => {
    setSeverity(SnackbarService.color);
  }, [SnackbarService.color]);

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={SnackbarService.open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={'message'}
        action={
          <>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} sx={{ mt: 0.25 }}>
              <CloseOutlined />
            </IconButton>
          </>
        }
      >
        <Alert style={{ fontSize: 16 }} onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
          {SnackbarService.text}
        </Alert>
      </Snackbar>
    </>
  );
});

export default MSnackbar;
